import React, { useState, useRef, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Fade, Slide } from 'react-slideshow-image'
import { ImageStyles, CarouselStyles } from './styles'
import { faImages } from '@fortawesome/pro-regular-svg-icons/faImages'
import { isInStorefront } from '../../utils/isInStorefront'

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faImages} size="6x" />
    </div>
)

const Image = ({ url, mobileUrl, alt, title }) => (
    <>
        {mobileUrl ? (
            <picture style={{ width: '100%' }}>
                <source srcSet={url} media="(min-width: 768px)" />
                <img src={mobileUrl} alt={alt} title={title} />
            </picture>
        ) : (
            <img src={url} alt={alt} title={title} />
        )}
    </>
)

const ImageContent = ({
    image: { url = '', mobileUrl = '', alt = '', title = '', link = '', openInNewTab = false },
}) => (
    <>
        {link.length > 0 ? (
            <a
                rel={openInNewTab ? 'nofollow noreferrer' : ''}
                href={link}
                target={openInNewTab ? '_blank' : '_self'}
            >
                <Image
                    title={title.length > 0 ? title : alt}
                    alt={alt}
                    url={url}
                    mobileUrl={mobileUrl}
                />
            </a>
        ) : (
            <Image
                title={title.length > 0 ? title : alt}
                alt={alt}
                url={url}
                mobileUrl={mobileUrl}
            />
        )}
    </>
)

const CarouselComponent = ({
    state: {
        slideDuration = 5000,
        transition = 'slide',
        transitionDuration = 1000,
        autoplay = false,
        pauseOnHover = true,
        showIndicators = false,
        indicatorsPosition = 'below',
        indicatorsColour = '#000',
        showArrows = true,
        arrowsColour = '#bababa',
        images = [],
        selectedImageIndex = 0,
    },
    isEditMode,
    onChange,
}) => {
    const slideRef = useRef()
    const [isLoaded, setIsLoaded] = useState(false)

    const transitionProperties = {
        duration: parseInt(slideDuration),
        transitionDuration: parseInt(transitionDuration),
        autoplay: !isEditMode && autoplay,
        indicators: showIndicators,
        arrows: showArrows,
        canSwipe: !isEditMode,
        pauseOnHover: pauseOnHover,
        easing: 'cubic',
        prevArrow: (
            <div className="nav default-nav" style={{ background: 'transparent' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill={arrowsColour}>
                    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"></path>
                </svg>
            </div>
        ),
        nextArrow: (
            <div className="nav default-nav" style={{ background: 'transparent' }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill={arrowsColour}>
                    <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path>
                </svg>
            </div>
        ),
    }

    const Components = {
        fade: Fade,
        slide: Slide,
    }

    const CarouselComponent = isEditMode ? Slide : Components[transition]

    useEffect(() => {
        if (slideRef.current && isEditMode && selectedImageIndex > 0 && isLoaded) {
            slideRef.current.goTo(parseInt(selectedImageIndex, 10))
        } else {
            // reset the selected image index to 0 on load
            onChange({ selectedImageIndex: 0 })
            setIsLoaded(true)
        }
    }, [selectedImageIndex, isEditMode])

    const inStorefront = isInStorefront()

    return (
        <>
            {images?.length > 0 ? (
                <CarouselStyles
                    indicatorsPosition={indicatorsPosition}
                    indicatorsColour={indicatorsColour}
                    className="content__carousel"
                >
                    <CarouselComponent ref={slideRef} {...transitionProperties}>
                        {images.map((image, idx) => (
                            <ImageStyles
                                onClick={e => {
                                    if (isEditMode) {
                                        e.preventDefault()
                                        onChange({ selectedImageIndex: idx })
                                    }
                                }}
                                selectedImage={isEditMode && selectedImageIndex === idx}
                                key={`carousel_img_${idx}_${image.url}`}
                            >
                                {image?.url && image?.url.length > 0 ? (
                                    <ImageContent image={image} />
                                ) : (
                                    <Icon />
                                )}
                            </ImageStyles>
                        ))}
                    </CarouselComponent>
                </CarouselStyles>
            ) : inStorefront ? (
                <></>
            ) : (
                <Icon />
            )}
        </>
    )
}

export default CarouselComponent
